module.exports = __webpack_public_path__ + "img/bottom_curve.29d944b2.svg";